export default "__VITE_ASSET__B5wq5GS3__"